import { el } from "./dom.js";

export function renderBoot(connected: boolean): HTMLElement {
  const stage = el("div", { class: "stage" });
  const card = el("div", { class: "card boot-card" });
  card.append(
    el("h1", { class: "logo" }, "Vinyl"),
    el("p", { class: "tagline" }, connected ? "Reconnecting…" : "Connecting to the world…"),
    el("div", { class: "spinner" }),
  );
  stage.append(card);
  return stage;
}
